import React, { Component } from "react";
import Button from "../../../Components/common/Button";
import SearchField from "../../../Components/common/SearchField";
import TextField from "../../../Components/common/TextField";
import MenuItem from "../../../Components/common/MenuItem";
import { connect } from "react-redux";
import isEqual from "react-fast-compare";
import { checkPrivileges } from "../../../Helpers";
import ConfirmDialoag from "../../../Components/common/ConfirmDialoag";
import Style from "style-it";
import Scrollbar from "react-scrollbars-custom";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../Loader";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import withTranslationWrapper from "../../../HOC/withTranslation";

class UserPmsSidebar extends Component {
  render() {
    const items = this.props.itemPagination?.items || [];
    const listRows = items.map((item) => (
      <ListRow
        key={item.id}
        item={item}
        pmsForm={this.props.pmsForm}
        themecolors={this.props.themecolors}
        openEditForm={this.props.openEditForm}
        deleteItem={this.props.deleteItem}
        updateItemStatus={this.props.updateItemStatus}
        statusUpdateId={this.props.statusUpdateId}
        translate={this.props.translate}
      />
    ));

    return (
      <Style>
        {`
          .material-icons {vertical-align: middle; color: inherit}
          .user-pms-card-list {
            padding: 8px 10px 0 !important;
          }
          .user-pms-card-list .user-pms-list-row {
            margin-bottom: 8px;
          }
          .user-pms-card-list .user-pms-list-row .user-pms-card {
            margin-left: 0;
            display: block;
            cursor: pointer;
          }
          .user-pms-card-list .user-pms-list-row .unit-name {
            max-width: none;
            min-width: 0;
            margin: 0;
            text-align: left;
          }
        `}
        <div className="fms-sidebar sidebar-bg-layer">
          {checkPrivileges("aiPms") && (
            <div>
              <div
                className="section-head clearfix section-head-filter"
                style={{
                  paddingTop: 0,
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h3
                  style={{ margin: 0, fontSize: 21 }}
                  className="alt-title sidebar-icon-gap"
                >
                  {this.props.translate("userPms")}
                </h3>
              </div>
              <div
                className="section-head section-head-filter"
                style={{ paddingTop: 0, paddingLeft: 10, paddingRight: 10 }}
              >
                <ul className="filter-row">
                  <li style={{ flex: 1 }} className="sidebar-icon-gap">
                    <SearchField
                      label={this.props.translate("sharedSearch")}
                      fullWidth
                      value={this.props.searchText || ""}
                      onChange={(e) => this.props.searchItems(e.target.value)}
                    />
                  </li>
                  <li style={{ flex: 1, minWidth: 120 }}>
                    <TextField
                      select
                      fullWidth
                      margin="dense"
                      label={this.props.translate("status")}
                      value={String(this.props.activeFilter ?? 2)}
                      onChange={(e) =>
                        this.props.onActiveFilterChange(e.target.value)
                      }
                    >
                      <MenuItem value="1">
                        {this.props.translate("active")}
                      </MenuItem>
                      <MenuItem value="0">
                        {this.props.translate("inactive")}
                      </MenuItem>
                      <MenuItem value="2">
                        {this.props.translate("all")}
                      </MenuItem>
                    </TextField>
                  </li>
                </ul>
              </div>
              <ul className="list-view with-padding-right geofence-sidebar-list user-pms-card-list">
                <Scrollbar
                  disableTracksWidthCompensation
                  scrollerProps={{
                    renderer: (props) => {
                      const { elementRef, ...restProps } = props;
                      return (
                        <div
                          {...restProps}
                          ref={elementRef}
                          id="userPmsScrollableDiv"
                        />
                      );
                    },
                  }}
                >
                  {this.props.listLoader && !items.length ? (
                    <Loader defaultStyle imgSize={50} />
                  ) : this.props.itemPagination ? (
                    <InfiniteScroll
                      dataLength={items.length}
                      next={this.props.fetchMoreItems}
                      hasMore={this.props.itemPagination.hasNext}
                      loader={<Loader defaultStyle imgSize={50} />}
                      scrollableTarget="userPmsScrollableDiv"
                      endMessage={this.props.endMessage}
                    >
                      {listRows}
                    </InfiniteScroll>
                  ) : null}
                </Scrollbar>
              </ul>
            </div>
          )}
        </div>
      </Style>
    );
  }
}

class ListRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onDeleteConfirmation: false,
      statusModalOpen: false,
      pendingActive: true,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  onRemovedItem = (e) => {
    e.stopPropagation();
    this.setState({ onDeleteConfirmation: true });
  };

  onCancel = () => {
    this.setState({ onDeleteConfirmation: false });
  };

  onDelete = () => {
    this.props.deleteItem(this.props.item.id);
    this.setState({ onDeleteConfirmation: false });
  };

  openEditForm = (e) => {
    e.stopPropagation();
    if (checkPrivileges("aiPms")) {
      this.props.openEditForm(this.props.item);
    }
  };

  openStatusModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (!checkPrivileges("aiPms")) {
      return;
    }
    this.setState({
      statusModalOpen: true,
      pendingActive: this.props.item.active !== false,
    });
  };

  closeStatusModal = () => {
    if (this.props.statusUpdateId === this.props.item.id) {
      return;
    }
    this.setState({ statusModalOpen: false });
  };

  onStatusChange = (e) => {
    this.setState({ pendingActive: e.target.value === "true" });
  };

  onStatusConfirm = () => {
    const { item, updateItemStatus } = this.props;
    const { pendingActive } = this.state;
    const isRecordActive = item.active !== false;

    if (isRecordActive === pendingActive) {
      this.setState({ statusModalOpen: false });
      return;
    }

    Promise.resolve(updateItemStatus(item, pendingActive)).then(() => {
      this.setState({ statusModalOpen: false });
    });
  };

  renderField = (label, value) => (
    <div style={{ display: "flex", gap: 6, fontSize: 12, lineHeight: 1.5 }}>
      <span style={{ opacity: 0.7, flexShrink: 0 }}>{label}:</span>
      <span style={{ fontWeight: 500, wordBreak: "break-word" }}>
        {value ?? "-"}
      </span>
    </div>
  );

  render() {
    const { item, pmsForm, themecolors, translate, statusUpdateId } =
      this.props;
    const isSelected = parseInt(pmsForm?.id, 10) === parseInt(item.id, 10);
    const isRecordActive = item.active !== false;
    const isStatusUpdating = statusUpdateId === item.id;
    const accentColor =
      themecolors?.menuActiveBackground || themecolors?.themeLightColor;

    return (
      <li
        className={`clearfix list-row  user-pms-list-row${isSelected ? " active" : ""}`}
        key={item.id}
        style={{ paddingRight: "2px" }}
      >
        <div
          className="user-pms-card"
          onClick={this.openEditForm}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              this.openEditForm(e);
            }
          }}
        >
          <div
            style={{
              borderRadius: 8,
              border: `1px solid ${themecolors?.themeListingColor || "#ddd"}4D`,

              background: isSelected
                ? `${accentColor}1A`
                : themecolors?.backgroundColor,
              padding: "10px 12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 8,
                marginBottom: 8,
              }}
            >
              <span
                className="unit-name"
                title={item.category}
                style={{ fontSize: 14, fontWeight: 600 }}
              >
                {item.category || "-"}
              </span>
              <div className="callout-actions" style={{ flexShrink: 0 }}>
                {checkPrivileges("aiPms") && (
                  <span className="action" onClick={this.openEditForm}>
                    <EditIcon className="material-icons" />
                  </span>
                )}
                {checkPrivileges("aiPms") && (
                  <span className="action" onClick={this.onRemovedItem}>
                    <DeleteIcon className="material-icons" />
                  </span>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
              }}
            >
              {this.renderField(
                translate("vehicleType"),
                item.fleetType || "-",
              )}
              {this.renderField(
                translate("baselineInterval"),
                item.baselineInterval != null ? item.baselineInterval : "-",
              )}
              {this.renderField(
                translate("baselineIntervalDays"),
                item.baselineIntervalDays != null
                  ? item.baselineIntervalDays
                  : "-",
              )}
              <div
                style={{
                  display: "flex",
                  gap: 6,
                  fontSize: 12,
                  lineHeight: 1.5,
                  alignItems: "center",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <span style={{ opacity: 0.7 }}>{translate("status")}:</span>
                {checkPrivileges("aiPms") ? (
                  <button
                    type="button"
                    onClick={this.openStatusModal}
                    style={{
                      background: "none",
                      border: "none",
                      padding: 0,
                      color: isRecordActive ? "#00C179" : "#E53935",
                      fontWeight: 600,
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: 12,
                    }}
                  >
                    {isRecordActive
                      ? translate("active")
                      : translate("inactive")}
                  </button>
                ) : (
                  <span
                    style={{
                      fontWeight: 600,
                      color: isRecordActive ? "#00C179" : "#E53935",
                    }}
                  >
                    {isRecordActive
                      ? translate("active")
                      : translate("inactive")}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.onDelete}
            title={this.props.translate("areYouWantToDelete")}
            children={item.category}
          />
        )}

        {this.state.statusModalOpen && (
          <Dialog
            open
            onClose={this.closeStatusModal}
            maxWidth="xs"
            fullWidth
            disableEscapeKeyDown={isStatusUpdating}
          >
            <DialogTitle>{translate("changeUserPmsStatus")}</DialogTitle>
            <DialogContent>
              <TextField
                select
                fullWidth
                margin="dense"
                label={translate("status")}
                value={String(this.state.pendingActive)}
                onChange={this.onStatusChange}
                disabled={isStatusUpdating}
              >
                <MenuItem value="true">{translate("active")}</MenuItem>
                <MenuItem value="false">{translate("inactive")}</MenuItem>
              </TextField>
            </DialogContent>
            <DialogActions style={{ padding: "8px 16px 16px" }}>
              <Button
                size="small"
                className="button-white"
                onClick={this.closeStatusModal}
                disabled={isStatusUpdating}
              >
                {translate("sharedCancel")}
              </Button>
              <Button
                size="small"
                onClick={this.onStatusConfirm}
                disabled={isStatusUpdating}
              >
                {isStatusUpdating ? (
                  <Loader defaultStyle imgSize={18} />
                ) : (
                  translate("update")
                )}
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </li>
    );
  }
}

const mapState = (state) => ({
  themecolors: state.themeColors,
});

export default connect(mapState)(withTranslationWrapper(UserPmsSidebar));
